<template>
    <div class="text-center my-3">
        <h3 class="font-weight-bold">
            <v-icon>mdi-format-list-bulleted-type</v-icon>
            DANH SÁCH PHÂN QUYỀN
        </h3>
    </div>
    <v-container>
        <v-row class="d-flex justify-center mx-auto" style="width: auto">
            <v-col cols="12" md="3">
                <v-combobox hide-details :return-object="false" v-model="cbxCompany" :items="dataCompany"
                    item-title="CompanyName" item-value="CompanyID" label="Chọn công ty"></v-combobox>
            </v-col>
            <v-col cols="12" md="3">
                <v-combobox hide-details :return-object="false" v-model="cbxProject" :items="dataProject"
                    item-title="ProjectName" item-value="ProjectID" label="Chọn projects"></v-combobox>
            </v-col>
            <v-col cols="12" md="3">
                <v-combobox hide-details :return-object="false" v-model="cbxModule" :items="dataModule"
                    item-title="ModuleName" item-value="ModuleID" label="Chọn modules"></v-combobox>
            </v-col>
            <v-col cols="12" md="2" class="d-flex align-center justify-center ml-n4">
                <v-btn :disabled="cbxModule === null ? true : false" elevation="0" color="primary"
                    @click="openDialogUpdatePhanQuyen(null)">
                    <v-icon class="mr-2">mdi-plus-circle</v-icon>
                    Thêm mới
                </v-btn>
            </v-col>
        </v-row>

    </v-container>

    <v-table style="width: 1000px" class="mx-auto">
        <thead>
            <tr>
                <th>Mã role</th>
                <th>Tên role</th>
                <th>Quyền</th>
                <th>Thao tác</th>

            </tr>
        </thead>
        <tbody>
            <tr v-for="item in dataPhanQuyen" :key="item.RoleID">
                <td>{{ item.RoleID }}</td>
                <td>{{ item.RoleName }}</td>
                <td>
                    <v-chip class="mx-1" v-for="p in JSON.parse(item.Permission)" :key="p.PermissionID">
                        {{ p.PermissionName }}
                    </v-chip>
                </td>

                <td>
                    <div style="display: flex; gap: 2px; align-items: center;">
                        <v-icon color="primary" @click="openDialogUpdatePhanQuyen(item)">mdi-pencil</v-icon>
                        <v-icon color="red" @click="showDialogDeleteConfirm(item)">mdi-delete</v-icon>
                    </div>
                </td>
            </tr>
        </tbody>
    </v-table>

    <!-- Hộp thoại Thêm, sửa dữ liệu -->
    <v-dialog width="500" scrollable v-model="showDialogUpdate">
        <template v-slot:default="{ isActive }">
            <v-card prepend-icon="mdi-pencil-plus-outline" :title="dialogUpdateTitle">
                <v-divider class="mb-3"></v-divider>
                <v-select class="mx-4" v-model="objPhanQuyen.RoleID" :items="dataRole" label="Chọn role"
                    item-title="RoleName" item-value="RoleID"></v-select>
                <v-select class="mx-4" multiple v-model="objPhanQuyen.PermissionID" :items="dataQuyen"
                    label="Chọn quyền" item-title="PermissionName" item-value="PermissionID"></v-select>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn text="ĐÓNG" @click="isActive.value = false"></v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" text="LƯU" variant="flat" @click="saveUpdateAction()"></v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>

    <!-- Hộp thoại xác nhận xóa -->
    <v-dialog v-model="showDialogDelete" max-width="500px">
        <v-card>
            <v-card-title class="headline">Xác nhận xoá</v-card-title>
            <v-divider class="mb-3"></v-divider>
            <v-card-text class="text-center">
                Bạn có chắc xoá dữ liệu không?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="gray" variant="flat" text @click="showDialogDelete = false">Huỷ</v-btn>
                <v-btn color="red" variant="flat" text @click="deleteAction()">Đồng ý</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>
<script>
import axios from '../utils/axios'
export default {
    name: 'PhanQuyenUserComponent',
    data: () => ({
        dataProject: [],
        dataCompany: [],
        dataModule: [],
        dataRole: [],
        cbxCompany: null,
        cbxModule: null,
        dataPhanQuyen: [],
        dataQuyen: [],
        cbxProject: null,
        showDialogUpdate: false,
        showDialogDelete: false,
        dialogUpdateTitle: "",
        objPhanQuyen: {
            RoleID: null,
            PermissionID: null,
            ModuleID: null
        },
        errorMessage: "",
        colorMessage: "blue"
    }),
    mounted() {
        this.getCompany()
        this.getQuyen()

    },
    watch: {
        cbxCompany() {
            this.getProject()
        },
        cbxProject() {
            this.getModule()
        },
        cbxModule() {
            this.getPhanQuyen()
            this.getRole()
        }
    },
    methods: {
        getRole() {
            this.dataRole = []
            axios.post('/Role_SelectByCompany', {
                CompanyID: this.cbxCompany,
                ProjectID: this.cbxProject
            })
                .then((response) => { this.dataRole = [...response.data] })
                .catch((error) => { console.log(error); });
        },
        getPhanQuyen() {
            this.dataPhanQuyen=[]
            axios.post('/RolePermission_SelectByModule', {
                ModuleID: this.cbxModule
            })
                .then((response) => { this.dataPhanQuyen = [...response.data] })
                .catch((error) => { console.log(error); });
        },

        getQuyen() {
            axios.get('/Permission_SelectAll', {
            })
                .then((response) => { this.dataQuyen = [...response.data] })
                .catch((error) => { console.log(error); });
        },

        getProject() {
            this.cbxProject = null
            this.cbxModule = null
            this.dataProject = []
            axios.post('/Project_SelectByCompany', {
                CompanyID: this.cbxCompany
            })
                .then((response) => { this.dataProject = [...response.data] })
                .catch((error) => { console.log(error); });
        },

        getCompany() {
            axios.get('/Company_SelectAll', {})
                .then((response) => { this.dataCompany = [...response.data] })
                .catch((error) => { console.log(error); });
        },

        getModule() {
            axios.post('/Module_SelectByProject', {
                ProjectID: this.cbxProject
            })
                .then((response) => { this.dataModule = [...response.data] })
                .catch((error) => { console.log(error); });
        },

        openDialogUpdatePhanQuyen(obj) {
            this.showDialogUpdate = true;
            if (obj == null) {
                this.dialogUpdateTitle = "Thêm mới Quyền"
                this.objPhanQuyen.RoleID = null;
                this.objPhanQuyen.PermissionID = null;
                this.objPhanQuyen.ModuleID = this.cbxModule;
            }
            else {
                this.dialogUpdateTitle = "Chỉnh sửa thông tin Quyền"
                this.objPhanQuyen.RoleID = obj.RoleID;
                this.objPhanQuyen.PermissionID = JSON.parse(obj.Permission).map(p => p.PermissionID);
                this.objPhanQuyen.ModuleID = obj.ModuleID;
            }
        },

        saveUpdateAction() {
            axios.post('/RolePermission_Add',
                {
                    ModuleID: this.cbxModule,
                    RoleID: this.objPhanQuyen.RoleID,
                    ListPermission: this.objPhanQuyen.PermissionID,
                })
                .then((response) => {
                    this.showDialogUpdate = false;
                    this.getPhanQuyen();
                    this.errorMessage = response.data.message;
                    this.colorMessage = "blue";
                })
                .catch((error) => {
                    this.errorMessage = error.response.data.message;
                    this.colorMessage = "red";
                    this.showDialogUpdate = false;
                });
        },

        showDialogDeleteConfirm(obj) {
            this.objPhanQuyen.RoleID = obj.RoleID;
            this.showDialogDelete = true;
        },

        deleteAction() {
            axios.post('/RolePermission_Delete',
                {
                    RoleID: this.objPhanQuyen.RoleID,
                    ModuleID: this.cbxModule,
                })
                .then((response) => {
                    this.getPhanQuyen();
                    this.showDialogDelete = false;
                    this.errorMessage = response.data.message;
                    this.colorMessage = "blue";
                })
                .catch((error) => {
                    this.errorMessage = error.response.data.message;
                    this.colorMessage = "red";
                    this.showDialogDelete = false;
                });
        },
    }
}
</script>